module.exports = __webpack_public_path__ + "static/media/400416_02.d7698d7a.png";